import { render, staticRenderFns } from "./GetASingleForm.vue?vue&type=template&id=21a82ff1&"
import script from "./GetASingleForm.vue?vue&type=script&lang=js&"
export * from "./GetASingleForm.vue?vue&type=script&lang=js&"
import style0 from "./GetASingleForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports